// Rendered on user base template
import init, { initWidgets } from 'src/lib/init.js'
import { initSelectAll } from "src/lib/select-all"

import Vue from 'vue'
import rootComponent from '@/root/item-related-search.js'
import 'src/styles/aristotle.table_browser.less'

new Vue(rootComponent)
initSelectAll()
init()

$(document).ready(function() {
    $('.modal').on('loaded.bs.modal', function() {
        initWidgets()
    })
})
